import DataIndexRoute from '@/features/data/DataIndexRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/data/')({
  component: DataIndexRoute,
});
